<template>

  <b-modal id="EmpresaUpdate" size="md" ref="modal" centered no-close-on-backdrop hide-footer>

    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title">Editar Grupo de Trabajo</h5>
      <button type="button" aria-label="Close" class="close" @click="close()" :disabled="loading">×</button>
    </template>

    <template slot="default" slot-scope="{ hide }">

      <b-form class="final_form" @submit.stop.prevent="editar" ref="form">

        <div class="final_form_container">

          <div class="final_form_input_group">
            <span class="final_form_group_input_label">Nombre:</span>
            <b-form-input class="inputText"
              v-model="nombre" 
              size="md" 
              :required="true"
              type="text" 
              :disabled="loading"/>
          </div>

          <div class="final_form_input_group">
            <span class="final_form_group_input_label">Repositorio:</span>
            <treeselect class="inputRelation"
              v-model="v2_repositorio_id" 
              size="md" 
              placeholder=""
              :required="false"
              :disabled="loading"
              :clearable="false" 
              :disable-branch-nodes="true" 
              :auto-load-root-options="false" 
              :cache-options="false" 
              :open-on-focus="true" 
              :options="repositorios"/>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" @click="hide()" class="btn btn-secondary" :disabled="loading">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="loading">Guardar</button>
        </div>

      </b-form>

    </template>

  </b-modal>

</template>

<script>

import moment from 'moment'
import Treeselect from '../utils/vue-treeselect/src/components/Treeselect'

export default {
  components: {
    Treeselect
  },
  data () {
    return {
      loading: false,
      empresa: {},
      nombre: '',
      repositorios: [],
      v2_repositorio_id: undefined
    }
  },
  methods: {
    setId (id) {
       try {
        if (!localStorage.signedIn) {
          this.$router.push('/')
        } else {

          this.loading = true
          this.v2_repositorio_id = undefined
          this.repositorios = []
          this.nombre = ''
          this.empresa = {}

          this.empresa.id = id;

          this.getEmpresaForUpdate(this.empresa.id)
          .then(data_empresa => {

            this.empresa = data_empresa.empresa
            this.nombre = data_empresa.empresa.identificacion

            var data = {}
            data.v2_empresa_id = data_empresa.empresa.id
            data.type = "getRepositoriosPorEmpresa"
            
            this.getRepositoriosPorEmpresa(data)
              .then(data => {
                this.repositorios = data.items

                data.items.forEach(element => {
                  if (element.selected >= 1) {
                    this.v2_repositorio_id = element.id
                  }
                });

                this.loading = false
              })
              
          })
        } 
      } catch (error) {
        this.loading = false
        this.showError(error)
      }
      
    },
    editar () {
      try {

        this.loading = true

        this.empresa.nombre_corto = this.cs(this.nombre)
        this.empresa.razon_social = this.cs(this.nombre)
        this.empresa.identificacion = this.cs(this.nombre)

        this.$http.secured.patch(`/desk/client/v1/v2_empresas/${this.empresa.id}`, { v2_empresa: this.empresa, v2_repositorio_id: this.v2_repositorio_id })
          .then(response => {       
            this.loading = false     
            this.showOK("Se actualizó el Grupo de Trabajo correctamente!")
            this.$emit('closeModal')
            this.$refs.modal.hide()
          })
          .catch(error => {
            this.loading = false
            this.showError(error)
          })  
      } catch (error) {
        this.loading = false
        this.showError(error)
      }
    }
  }
}
</script>
